module.exports = __webpack_public_path__ + "static/media/scratch-off-nfc-one.c3872d55.svg";